/* gara-geo-waitlist.js — geo-targeted "we're not shipping to your state yet" popup + email capture.
 * Fires ONLY for visitors whose IP geolocates to a blocked state (window.GARA_WL_STATES, set in
 * snippets/gara-geo-waitlist.liquid). Captures email into a Shopify customer tagged waitlist-<ST>
 * so the store can email that segment the moment the state reopens. Shows once per session.
 * Fail-safe: any geo/network error => no popup (never blocks or errors the page). */
(function () {
  'use strict';
  try { if (sessionStorage.getItem('gara_wl_shown')) return; } catch (e) {}

  var STATES = (window.GARA_WL_STATES || []).map(function (s) { return String(s).toUpperCase(); });
  if (!STATES.length) return;

  var NAMES = {
    AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',
    DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',
    KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',
    MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',
    NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',
    OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',
    TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',
    WI:'Wisconsin',WY:'Wyoming',DC:'the District of Columbia'
  };

  var overlay = document.getElementById('gara-wl-overlay');
  if (!overlay) return;

  function hide() { overlay.hidden = true; document.body.style.overflow = ''; }

  function show(code) {
    try { sessionStorage.setItem('gara_wl_shown', '1'); } catch (e) {}
    var st = document.getElementById('gara-wl-state');
    if (st) st.textContent = NAMES[code] || 'your state';
    var tags = document.getElementById('gara-wl-tags');
    if (tags) tags.value = 'waitlist-' + code;
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  var closeBtn = document.getElementById('gara-wl-close');
  if (closeBtn) closeBtn.addEventListener('click', hide);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) hide(); });

  var form = document.getElementById('gara-wl-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = document.getElementById('gara-wl-email');
      if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) { if (email) email.focus(); return; }
      var fd = new FormData(form);
      fetch(form.getAttribute('action') || window.location.pathname,
            { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(done, done);
    });
  }
  function done() {
    var w = document.getElementById('gara-wl-form-wrap');
    var s = document.getElementById('gara-wl-success');
    if (w) w.hidden = true;
    if (s) s.hidden = false;
    setTimeout(hide, 4000);
  }

  // --- geo detect (IP -> US state), 4s timeout, fail-safe silent ---
  var opts = {};
  if ('AbortController' in window) {
    var ctrl = new AbortController();
    opts.signal = ctrl.signal;
    setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 4000);
  }
  fetch('https://ipapi.co/json/', opts)
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || (d.country_code && d.country_code !== 'US')) return;
      var code = (d.region_code || '') ? String(d.region_code).toUpperCase() : '';
      if (code && STATES.indexOf(code) !== -1) show(code);
    })
    .catch(function () {});
})();
